import { MLink } from "@/lib/marketing/m-link";

export function FooterColumn({
  title,
  links,
}: {
  title: string;
  links: { label: string; href: string; external?: boolean }[];
}) {
  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
      <ul className="space-y-2">
        {links.map((l) => {
          const testId = `link-footer-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`;
          const content = (
            <span
              className="cursor-pointer text-sm text-foreground/80 hover-elevate rounded-md px-1 py-0.5 -mx-1 inline-block"
              data-testid={testId}
            >
              {l.label}
            </span>
          );
          return (
            <li key={l.label}>
              {l.external ? <a href={l.href}>{content}</a> : <MLink href={l.href}>{content}</MLink>}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
